import React, { useState, useEffect, useRef } from 'react';
import './NewProduct.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faImage } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../../url';
import { compressImageToWebP } from '../../../utils/imageCompression';
import { adminFetch } from '../../../utils/api';
export default function NewProduct() {
    const [mensaje, setMensaje] = useState('');
    const [imagenPreview1, setImagenPreview1] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    
    // Estados para archivos comprimidos
    const [compressedFile1, setCompressedFile1] = useState(null);
    const [compressedFile2, setCompressedFile2] = useState(null);
    const [compressedFile3, setCompressedFile3] = useState(null);
    const [compressedFile4, setCompressedFile4] = useState(null);
    
    // Refs para inputs de archivo
    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);
    const fileInputRef3 = useRef(null);
    const fileInputRef4 = useRef(null);
    const [descripcion, setDescripcion] = useState('');
    const [titulo, setTitulo] = useState('');
    const [categoria, setCategoria] = useState('');
    const [esAccesorio, setEsAccesorio] = useState("");
    const [masVendido, setMasVendido] = useState('');
    const [visible, setVisible] = useState('1');
    const [precio, setPrecio] = useState('');
    const [isImage1Selected, setIsImage1Selected] = useState(false);
    const [isImage2Selected, setIsImage2Selected] = useState(false);
    const [isImage3Selected, setIsImage3Selected] = useState(false);
    const [isImage4Selected, setIsImage4Selected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState("Ch");
    const [item2, setItem2] = useState("M");
    const [item3, setItem3] = useState("G");
    const [item4, setItem4] = useState("Xg");
    const [item5, setItem5] = useState("Xxg");
    const [stockItem1, setStockItem1] = useState(0);
    const [stockItem2, setStockItem2] = useState(0);
    const [stockItem3, setStockItem3] = useState(0);
    const [stockItem4, setStockItem4] = useState(0);
    const [stockItem5, setStockItem5] = useState(0);
    const [precioAnterior, setPrecioAnterior] = useState('0');
    const [viewAllSizes, setViewAllSizes] = useState(true);
    const [modulo, setModulo] = useState("");
    const [nivel, setNivel] = useState("");

    // Estados para manejo de errores
    const [errors, setErrors] = useState({});
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
        // Limpiar errores al abrir el modal
        if (!modalOpen) {
            setErrors({});
            setHasSubmitted(false);
        }
    };
    const handleImagenChange = async (event, setImagenPreview, setIsImageSelected, imageNumber, setCompressedFile) => {
        const file = event.target.files[0];

        if (file) {
            try {
                // Mostrar mensaje de procesamiento
                toast.info('Comprimiendo imagen a WebP...', { autoClose: 1000 });
                
                // Comprimir y convertir a WebP
                const compressedWebP = await compressImageToWebP(file, {
                    quality: 0.82, // 82% de calidad
                    maxWidthOrHeight: 2000 // Máximo 2000px en cualquier dimensión
                });
                
                // Crear preview del archivo comprimido
                const previewURL = URL.createObjectURL(compressedWebP);
                setImagenPreview(previewURL);
                setIsImageSelected(true);
                
                // Guardar archivo comprimido para enviar al servidor
                setCompressedFile(compressedWebP);
                
                // Mostrar información de compresión
                const originalSize = (file.size / 1024).toFixed(2);
                const compressedSize = (compressedWebP.size / 1024).toFixed(2);
                const reduction = ((1 - compressedWebP.size / file.size) * 100).toFixed(1);
                
                toast.success(
                    `✓ Imagen ${imageNumber} optimizada: ${originalSize}KB → ${compressedSize}KB (${reduction}% reducción)`,
                    { autoClose: 3000 }
                );
                
                // Limpiar error de imagen si existe
                if (hasSubmitted) {
                    setErrors(prev => ({
                        ...prev,
                        [`imagen${imageNumber}`]: ''
                    }));
                }
            } catch (error) {
                console.error('Error al comprimir imagen:', error);
                toast.error(`Error al procesar imagen ${imageNumber}: ${error.message}`);
            }
        }
    };


    const crear = async () => {
        setHasSubmitted(true);
        
        if (!validateForm()) {
            toast.error('Por favor, corrija los errores en el formulario.');
            return;
        }

        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        
        // Reemplazar imágenes originales con versiones comprimidas en WebP
        if (compressedFile1) {
            formData.delete('imagen1');
            formData.append('imagen1', compressedFile1);
        }
        if (compressedFile2) {
            formData.delete('imagen2');
            formData.append('imagen2', compressedFile2);
        }
        if (compressedFile3) {
            formData.delete('imagen3');
            formData.append('imagen3', compressedFile3);
        }
        if (compressedFile4) {
            formData.delete('imagen4');
            formData.append('imagen4', compressedFile4);
        }
        
        const resetForm = () => {
            form.reset();
            setImagenPreview1(null);
            setImagenPreview2(null);
            setImagenPreview3(null);
            setImagenPreview4(null);
            setCompressedFile1(null);
            setCompressedFile2(null);
            setCompressedFile3(null);
            setCompressedFile4(null);
            setIsImage1Selected(false);
            setIsImage2Selected(false);
            setIsImage3Selected(false);
            setIsImage4Selected(false);
            setTitulo('');
            setPrecio('');
            setCategoria('');
            setEsAccesorio('');
            setMasVendido('');
            setVisible('1');
            setDescripcion('');
            setPrecioAnterior('');
            setModulo('');
            setNivel('');
            setStockItem1(0);
            setStockItem2(0);
            setStockItem3(0);
            setStockItem4(0);
            setStockItem5(0);
            setErrors({});
            setHasSubmitted(false);
        };
        setMensaje('');

        setMensaje('Procesando...');

        try {

            if (!formData.get("stockItem2")) {
                formData.append("stockItem2", 0);
            }
            if (!formData.get("stockItem3")) {
                formData.append("stockItem3", 0);
            }
            if (!formData.get("stockItem4")) {
                formData.append("stockItem4", 0);
            }
            if (!formData.get("stockItem5")) {
                formData.append("stockItem5", 0);
            }

            formData.append("item1", item1);
            formData.append("item2", item2);
            formData.append("item3", item3);
            formData.append("item4", item4);
            formData.append("item5", item5);
            formData.append("visible", visible);
            const response = await adminFetch(`${baseURL}/api/admin/productos`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);

            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');

        }
    };


    const handleCategoriaChange = (e) => {
        handleFieldChange('idCategoria', e.target.value, setCategoria);
    };

    const handleEsAccesorioChange = (e) => {
        handleFieldChange('esAccesorio', e.target.value, setEsAccesorio);
        if (e.target.value == "si") {
            setViewAllSizes(false);
        } else {
            setViewAllSizes(true);
        }
    };

    const handleMasVendidoChange = (e) => {
        handleFieldChange('masVendido', e.target.value, setMasVendido);
    };

    useEffect(() => {
        cargarCategoria();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/api/categorias`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    // Función para validar campos
    const validateField = (name, value) => {
        switch (name) {
            case 'titulo':
                return value.trim() === '' ? 'El título es obligatorio' : '';
            case 'precio':
                return value === '' || parseFloat(value) <= 0 ? 'El precio es obligatorio y debe ser mayor a 0' : '';
            case 'idCategoria':
                return value === '' ? 'Debe seleccionar una categoría' : '';
            case 'esAccesorio':
                return value === '' ? 'Debe seleccionar si es accesorio' : '';
            case 'masVendido':
                return value === '' ? 'Debe seleccionar si es más vendido' : '';
            case 'stockItem1':
                return value === '' || parseInt(value) < 0 ? 'El stock del item 1 es obligatorio y debe ser mayor o igual a 0' : '';
            default:
                return '';
        }
    };

    // Función para validar todo el formulario
    const validateForm = () => {
        const newErrors = {};
        
        newErrors.titulo = validateField('titulo', titulo);
        newErrors.precio = validateField('precio', precio);
        newErrors.idCategoria = validateField('idCategoria', categoria);
        newErrors.esAccesorio = validateField('esAccesorio', esAccesorio);
        newErrors.masVendido = validateField('masVendido', masVendido);
        newErrors.stockItem1 = validateField('stockItem1', stockItem1);

        setErrors(newErrors);
        return !Object.values(newErrors).some(error => error !== '');
    };

    // Función para manejar cambios en campos con validación
    const handleFieldChange = (fieldName, value, setter) => {
        setter(value);
        if (hasSubmitted) {
            const error = validateField(fieldName, value);
            setErrors(prev => ({
                ...prev,
                [fieldName]: error
            }));
        }
    };


    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span> Agregar
            </button>
            {modalOpen && (
                <div className="modal new-product-modal">
                    <div className="modal-content new-product-modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Producto</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">

                            <div className='flexGrap'>
                                <fieldset className={errors.titulo ? 'error' : 'required'}>
                                    <legend>Título</legend>
                                    <input
                                        type="text"
                                        id="titulo"
                                        name="titulo"
                                        required
                                        value={titulo}
                                        onChange={(e) => handleFieldChange('titulo', e.target.value, setTitulo)}
                                    />
                                    {errors.titulo && <p className="error-message">{errors.titulo}</p>}
                                </fieldset>

                                <fieldset className={errors.precio ? 'error' : 'required'}>
                                    <legend>Precio</legend>
                                    <input
                                        type="number"
                                        id="precio"
                                        name="precio"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precio}
                                        onChange={(e) => handleFieldChange('precio', e.target.value, setPrecio)}
                                    />
                                    {errors.precio && <p className="error-message">{errors.precio}</p>}
                                </fieldset>

                                <fieldset className={errors.idCategoria ? 'error' : 'required'}>
                                    <legend>Categoría</legend>
                                    <select
                                        id="idCategoria"
                                        name="idCategoria"
                                        value={categoria}
                                        onChange={handleCategoriaChange}
                                    >
                                        <option value="">Selecciona una categoría</option>
                                        {categorias.map(item => (
                                            <option key={item.idCategoria} value={item.idCategoria}>{item.categoria}</option>
                                        ))}
                                    </select>
                                    {errors.idCategoria && <p className="error-message">{errors.idCategoria}</p>}
                                </fieldset>

                                <fieldset className={errors.esAccesorio ? 'error' : 'required'}>
                                    <legend>Es Accesorio</legend>
                                    <select
                                        id="esAccesorio"
                                        name="esAccesorio"
                                        value={esAccesorio}
                                        onChange={(e) => handleFieldChange('esAccesorio', e.target.value, setEsAccesorio)}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                    {errors.esAccesorio && <p className="error-message">{errors.esAccesorio}</p>}
                                </fieldset>
                                <fieldset className={errors.masVendido ? 'error' : 'required'}>
                                    <legend>Más vendido</legend>
                                    <select
                                        id="masVendido"
                                        name="masVendido"
                                        value={masVendido}
                                        onChange={(e) => handleFieldChange('masVendido', e.target.value, setMasVendido)}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>

                                    </select>
                                    {errors.masVendido && <p className="error-message">{errors.masVendido}</p>}
                                </fieldset>

                                <fieldset>
                                    <legend>Visible al público</legend>
                                    <select
                                        id="visible"
                                        name="visible"
                                        value={visible}
                                        onChange={(e) => setVisible(e.target.value)}
                                    >
                                        <option value="1">Sí (Mostrar)</option>
                                        <option value="0">No (Ocultar)</option>
                                    </select>
                                </fieldset>

                                <fieldset id='descripcion'>
                                    <legend>Descripción</legend>
                                    <textarea
                                        id="descripcion"
                                        name="descripcion"
                                        required
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        placeholder="Descripción"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        id="precioAnterior"
                                        name="precioAnterior"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precioAnterior}
                                        onChange={(e) => setPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Módulo</legend>
                                    <input
                                        type="text"
                                        id="modulo"
                                        name="modulo"
                                        value={modulo}
                                        onChange={(e) => setModulo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Nivel</legend>
                                    <input
                                        type="text"
                                        id="nivel"
                                        name="nivel"
                                        value={nivel}
                                        onChange={(e) => setNivel(e.target.value)}
                                    />
                                </fieldset>
                                <div className="items">
                                    <fieldset>
                                        <legend>Talla 1</legend>
                                        <input
                                            type="text"
                                            id="item1"
                                            name="item1"
                                            required
                                            value={item1}
                                            onChange={(e) => setItem1(e.target.value)}
                                            disabled
                                        />
                                    </fieldset>
                                    <fieldset className={errors.stockItem1 ? 'error' : 'required'}>
                                        <legend>Cant. 1</legend>
                                        <input
                                            type="number"
                                            id="stockItem1"
                                            name="stockItem1"
                                            required
                                            value={stockItem1}
                                            onChange={(e) => handleFieldChange('stockItem1', e.target.value, setStockItem1)}
                                        />
                                        {errors.stockItem1 && <p className="error-message">{errors.stockItem1}</p>}
                                    </fieldset>

                                    {viewAllSizes && (
                                        <>
                                            <fieldset>
                                                <legend>Talla 2</legend>
                                                <input
                                                    type="text"
                                                    id="item2"
                                                    name="item2"
                                                    required
                                                    value={item2}
                                                    onChange={(e) => setItem2(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant. 2</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem2"
                                                    name="stockItem2"
                                                    required
                                                    value={stockItem2}
                                                    onChange={(e) => setStockItem2(e.target.value)}
                                                />
                                            </fieldset>

                                            <fieldset>
                                                <legend>Talla 3</legend>
                                                <input
                                                    type="text"
                                                    id="item3"
                                                    name="item3"
                                                    required
                                                    value={item3}
                                                    onChange={(e) => setItem3(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant. 3</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem3"
                                                    name="stockItem3"
                                                    required
                                                    value={stockItem3}
                                                    onChange={(e) => setStockItem3(e.target.value)}
                                                />
                                            </fieldset>

                                            <fieldset>
                                                <legend>Talla 4</legend>
                                                <input
                                                    type="text"
                                                    id="item4"
                                                    name="item4"
                                                    required
                                                    value={item4}
                                                    onChange={(e) => setItem4(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant. 4</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem4"
                                                    name="stockItem4"
                                                    required
                                                    value={stockItem4}
                                                    onChange={(e) => setStockItem4(e.target.value)}
                                                />
                                            </fieldset>

                                            <fieldset>
                                                <legend>Talla 5</legend>
                                                <input
                                                    type="text"
                                                    id="item5"
                                                    name="item5"
                                                    required
                                                    value={item5}
                                                    onChange={(e) => setItem5(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant. 5</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem5"
                                                    name="stockItem5"
                                                    required
                                                    value={stockItem5}
                                                    onChange={(e) => setStockItem5(e.target.value)}
                                                />
                                            </fieldset>
                                        </>
                                    )}
                                </div>

                                {/* SECCIÓN DE IMÁGENES CON NUEVO DISEÑO */}
                                <div className='images-upload-section'>
                                    <span className='section-title'>Imágenes del Producto</span>
                                    <div className='images-grid'>
                                        {/* Imagen 1 */}
                                        <div className='image-upload-item'>
                                            <div className='preview-box-small' onClick={() => fileInputRef1.current.click()}>
                                                {imagenPreview1 ? (
                                                    <img src={imagenPreview1} alt="Imagen 1" className='img-preview-full' />
                                                ) : (
                                                    <div className='placeholder-content-small'>
                                                        <FontAwesomeIcon icon={faImage} size="lg" />
                                                        <span>1</span>
                                                    </div>
                                                )}
                                            </div>
                                            <input 
                                                type="file" 
                                                id="imagen1"
                                                name="imagen1"
                                                accept="image/*"
                                                ref={fileInputRef1}
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleImagenChange(e, setImagenPreview1, setIsImage1Selected, 1, setCompressedFile1)}
                                            />
                                            <button type="button" className='btn-upload-small' onClick={() => fileInputRef1.current.click()}>
                                                <FontAwesomeIcon icon={faUpload} /> {imagenPreview1 ? 'Cambiar' : 'Subir'}
                                            </button>
                                        </div>

                                        {/* Imagen 2 */}
                                        <div className='image-upload-item'>
                                            <div className='preview-box-small' onClick={() => fileInputRef2.current.click()}>
                                                {imagenPreview2 ? (
                                                    <img src={imagenPreview2} alt="Imagen 2" className='img-preview-full' />
                                                ) : (
                                                    <div className='placeholder-content-small'>
                                                        <FontAwesomeIcon icon={faImage} size="lg" />
                                                        <span>2</span>
                                                    </div>
                                                )}
                                            </div>
                                            <input 
                                                type="file" 
                                                id="imagen2"
                                                name="imagen2"
                                                accept="image/*"
                                                ref={fileInputRef2}
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleImagenChange(e, setImagenPreview2, setIsImage2Selected, 2, setCompressedFile2)}
                                            />
                                            <button type="button" className='btn-upload-small' onClick={() => fileInputRef2.current.click()}>
                                                <FontAwesomeIcon icon={faUpload} /> {imagenPreview2 ? 'Cambiar' : 'Subir'}
                                            </button>
                                        </div>

                                        {/* Imagen 3 */}
                                        <div className='image-upload-item'>
                                            <div className='preview-box-small' onClick={() => fileInputRef3.current.click()}>
                                                {imagenPreview3 ? (
                                                    <img src={imagenPreview3} alt="Imagen 3" className='img-preview-full' />
                                                ) : (
                                                    <div className='placeholder-content-small'>
                                                        <FontAwesomeIcon icon={faImage} size="lg" />
                                                        <span>3</span>
                                                    </div>
                                                )}
                                            </div>
                                            <input 
                                                type="file" 
                                                id="imagen3"
                                                name="imagen3"
                                                accept="image/*"
                                                ref={fileInputRef3}
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleImagenChange(e, setImagenPreview3, setIsImage3Selected, 3, setCompressedFile3)}
                                            />
                                            <button type="button" className='btn-upload-small' onClick={() => fileInputRef3.current.click()}>
                                                <FontAwesomeIcon icon={faUpload} /> {imagenPreview3 ? 'Cambiar' : 'Subir'}
                                            </button>
                                        </div>

                                        {/* Imagen 4 */}
                                        <div className='image-upload-item'>
                                            <div className='preview-box-small' onClick={() => fileInputRef4.current.click()}>
                                                {imagenPreview4 ? (
                                                    <img src={imagenPreview4} alt="Imagen 4" className='img-preview-full' />
                                                ) : (
                                                    <div className='placeholder-content-small'>
                                                        <FontAwesomeIcon icon={faImage} size="lg" />
                                                        <span>4</span>
                                                    </div>
                                                )}
                                            </div>
                                            <input 
                                                type="file" 
                                                id="imagen4"
                                                name="imagen4"
                                                accept="image/*"
                                                ref={fileInputRef4}
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleImagenChange(e, setImagenPreview4, setIsImage4Selected, 4, setCompressedFile4)}
                                            />
                                            <button type="button" className='btn-upload-small' onClick={() => fileInputRef4.current.click()}>
                                                <FontAwesomeIcon icon={faUpload} /> {imagenPreview4 ? 'Cambiar' : 'Subir'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}


                        </form>
                    </div>
                </div>
            )}

        </div>
    );
}

